__webpack_require__.p = "/instream.panel/static/e/2/";